export default {
  getCategories: {
    uri: 'categories',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  fromPagination: {
    method: 'GET',
    loading: true,
    subdomain: false,
    needsVerified: false,
    absouluteUrl: true
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/global.js